module.exports = __webpack_public_path__ + "img/total-yesterday.306b1b7a.svg";